module.exports = __webpack_public_path__ + "fnb-wim-logo.52c7002033777ced8a54.svg";